import {Language} from 'shared/const/locales';
import {CompanyId} from './Company';

export const DOCTOR = 'doctor';
export const PATIENT = 'patient';

export enum UserType {
  Doctor = 'doctor',
  Patient = 'patient'
}

interface Company {
  id: CompanyId;
}

export type UserId = string;

export default interface User {
  readonly id: UserId;
  readonly company: Company;
  readonly name: string;
  readonly surname: string;
  readonly secondSurname: string | null;
  readonly gender: string | null;
  readonly locale: Language;
  readonly fullname: string;
  readonly country: string | null;
  readonly email: string | null;
  readonly image: string | null;
  readonly isEnabled: boolean;
  readonly type: UserType;
  readonly allowsReceiveEmails: boolean;
}
